// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".download[data-v-b66361d6]{background-color:#f5f7fd;padding:30px 0}.download .main-con[data-v-b66361d6]{min-height:700px;width:1200px;margin:0 auto;background-color:#fff;padding:20px}.download .page[data-v-b66361d6]{margin-top:1em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
